/* eslint-disable eqeqeq */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { capitalize } from '@material-ui/core';
import { minPermisos } from '../../../constants/permits';

const PermisosList = ({
  permit = [],
  permits = [],
  onUpdatePermit,
  onDeletePermit,
  user,
}) => {
  const canUse = (userPermissions, permission) => {
    let CanUse = false;
    // eslint-disable-next-line prefer-destructuring
    CanUse = userPermissions.filter(
      (userPermission) => userPermission.permiso_id == permission.id,
    )[0];
    return CanUse ? CanUse.tipo_id : 0;
  };
  const handleChangeCheck = (event, value) => {
    event.preventDefault();
    const permisoId = event.target.value;
    const valuePermit = value;

    if (
      event.target.checked === false
      && valuePermit == minPermisos.VISUALIZAR
    ) {
      // permisoList.tipo_id = value - 1
      onDeletePermit({
        usuario_id: user.id,
        permiso_id: permisoId,
      });
    } else if (event.target.checked === false) {
      // permisoList.tipo_id = value - 1
      onUpdatePermit({
        usuario_id: user.id,
        permiso_id: permisoId,
        tipo_id: value - 1,
      });
    } else {
      // permisoList.tipo_id = value
      onUpdatePermit({
        usuario_id: user.id,
        permiso_id: permisoId,
        tipo_id: value,
      });
    }
  };

  return (
    <List>
      {Array.isArray(permits) ? (
        permits.map((permitList, index) => {
          const userPermissionLevel = canUse(permit, permitList);
          return (
            <ListItem divider key={permitList.permiso}>
              <Grid item xs={6}>
                <ListItemText
                  primary={`${permitList.id} - ${capitalize(
                    permitList.permiso,
                  )} `}
                />
              </Grid>
              <Grid item xs={12} md={2} sm={2}>
                <FormControlLabel
                  control={(
                    <Switch
                      id={`${index}`}
                      checked={userPermissionLevel >= minPermisos.VISUALIZAR}
                      onChange={(event) => handleChangeCheck(event, minPermisos.VISUALIZAR)}
                      value={permitList.id}
                    />
                  )}
                  label="Visualizar"
                  labelPlacement="top"
                />
              </Grid>
              <Grid item xs={12} md={2} sm={2}>
                <FormControlLabel
                  control={(
                    <Switch
                      id={`${index}`}
                      checked={userPermissionLevel >= minPermisos.CREAR}
                      onChange={(event) => handleChangeCheck(event, minPermisos.CREAR)}
                      value={permitList.id}
                    />
                  )}
                  label="Crear"
                  labelPlacement="top"
                />
              </Grid>
              <Grid item xs={12} md={2} sm={2}>
                <FormControlLabel
                  control={(
                    <Switch
                      id={`${index}`}
                      checked={userPermissionLevel >= minPermisos.ACTUALIZAR}
                      onChange={(event) => handleChangeCheck(event, minPermisos.ACTUALIZAR)}
                      value={permitList.id}
                    />
                  )}
                  label="Actualizar"
                  labelPlacement="top"
                />
              </Grid>
              <Grid item xs={12} md={2} sm={2}>
                <FormControlLabel
                  control={(
                    <Switch
                      id={`${index}`}
                      checked={userPermissionLevel >= minPermisos.ELIMINAR}
                      onChange={(event) => handleChangeCheck(event, minPermisos.ELIMINAR)}
                      value={permitList.id}
                    />
                  )}
                  label="Eliminar"
                  labelPlacement="top"
                />
              </Grid>
              <Grid item xs={12} md={2} sm={2}>
                <FormControlLabel
                  control={(
                    <Switch
                      id={`${index}`}
                      checked={userPermissionLevel >= minPermisos.ADMINISTATIVO}
                      onChange={(event) => handleChangeCheck(event, minPermisos.ADMINISTATIVO)}
                      value={permitList.id}
                    />
                  )}
                  label="Administrar"
                  labelPlacement="top"
                />
              </Grid>
            </ListItem>
          );
        })
      ) : (
        <p>...Cargando Permisos</p>
      )}
    </List>
  );
};

export default PermisosList;
